import { render, staticRenderFns } from "./SendMessageTargetGroupRow.vue?vue&type=template&id=cdc85cdc&scoped=true&lang=pug"
import script from "./SendMessageTargetGroupRow.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetGroupRow.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetGroupRow.vue?vue&type=style&index=0&id=cdc85cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc85cdc",
  null
  
)

export default component.exports